module.exports = __webpack_public_path__ + "media/images/contest-banner-8e9bf1d858e8b5956b02a71bcd2749e9.png";